module.exports = __webpack_public_path__ + "images/emoji/arrows_clockwise.bb2ab977b4412ce33dbb.png";